import React, { createContext, useReducer } from "react";
import AppReducer from "./AppReducer";
const user = JSON.parse(sessionStorage.getItem("user"));


// encryption soon
const initialState = {
  Profileinfo: null,
  token: null,
  user: user,
  transactionLoader: false,
  accessData: null,
  accessDataemp: null,
};
export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  function setTransactionLoaderState(loaderState) {
    dispatch({
      type: "SET_TRANSACTION_LOADER",
      payload: loaderState,
    });
  }

  function setToken(token) {
    dispatch({
      type: "SET_TOKEN",
      payload: token,
    });
  }
  function setProfileinfo(info) {
    console.log(info);
    dispatch({
      type: "SET_MY_ACCOUNT_INFO",
      payload: info,
    });
  }
  function setMyAccountInfo(info) {
    sessionStorage.setItem("accountDetails", JSON.stringify(info));
    dispatch({
      type: "SET_MY_ACCOUNT_INFO_DEVELOPER",
      payload: info,
    });
  }
  function logoutDeveloperLogin() {
    sessionStorage.removeItem("accountDetails");
    dispatch({
      type: "LOG_OUT_DEVELOPER",
      payload: null,
    });
  }
  function removeMyAccountInfo() {
    sessionStorage.removeItem("accountDetails");
    dispatch({
      type: "REMOVE_MY_ACCOUNT_INFO_DEVELOPER",
      payload: null,
    });
  }
 
 

  function setAccessemployeData(accessDataemp) {
    console.log('Setting Access Data EMP:', accessDataemp);  
    dispatch({
      type: 'SET_ACCESS_DATA_EMP',
      payload: accessDataemp
    });
  }


  return (
    <GlobalContext.Provider
      value={{
        accessData: state.accessData,
        accessDataemp: state.accessDataemp,
        setAccessemployeData,
        token: state.token,
        user: state.user,
        Profileinfo: state.Profileinfo,
        setToken,
        setProfileinfo,
        setMyAccountInfo,
        setTransactionLoaderState,
        removeMyAccountInfo,
        logoutDeveloperLogin
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};



